import * as React from 'react'
import { Formik } from 'formik'

import type { ILeadMissingFieldDTO } from '@user/store/lead/typings'

import { LeadCompanyRequiredFieldsForm } from './LeadCompanyRequiredFieldsForm'
import { useData } from './hooks/useData'
import { useHandlers } from './hooks/useHandlers'
import { useInitialValues } from './hooks/useInitialValues'
import type { LeadCompanyRequiredFieldsFormValues } from './hooks/useInitialValues'
import { useValidate } from './hooks/useValidate'

interface Props {
  leadId: number
  missingFields: ILeadMissingFieldDTO[]
  onClose: () => void
  onSaved: () => void
}

export function LeadCompanyRequiredFieldsContent(props: Props) {
  const { leadId, missingFields, onClose, onSaved } = props

  const data = useData(missingFields)
  const initialValues = useInitialValues(data.customFields)
  const validate = useValidate({
    fields: data.fields,
    extraKeys: data.extraKeys,
  })
  const { onSubmit } = useHandlers({ leadId, data, onClose, onSaved })

  return (
    <Formik<LeadCompanyRequiredFieldsFormValues>
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validate}
    >
      <LeadCompanyRequiredFieldsForm data={data} onClose={onClose} />
    </Formik>
  )
}

LeadCompanyRequiredFieldsContent.displayName =
  'LeadCompanyRequiredFieldsContent'
